export const composant = {
  modal_select_filiale: {
    title: 'Sélection de la filiale pour la création',
    code: 'Code',
    nom: 'Nom',
    left_title: 'Signataires seul',
    middle_title: 'Signataires double',
    right_title: 'Mobiles',
    other_title: '',
  },
  details_operation: {
    title: "Détail de l'operation {{name}}",
    libelle: "Libellé de l'opération",
    libelle_complementaire: 'Libellé complémentaire',
    motif: 'Motif',
    montant: 'Montant',
    exempted: 'Exonéré',
    date_operation: "Date de l'opération",
    date_valeur: 'Date de valeur',
    reference: 'Référence',
    endtoend: 'Référence de client à client',
    category: 'Catégorie',
    code_operation: 'Code opération',
    nom_payeur: 'Nom du payeur',
    id_payeur: 'Id du payeur',
    nom_payeur_final: 'Nom du payeur final',
    nom_beneficiaire: 'Nom du bénéficiaire',
    id_beneficiaire: 'Id du bénéficiaire',
    nom_beneficiaire_final: 'Nom du bénéficiaire final',
    id_beneficiaire_final: 'Id du bénéficiaire final',
    reference_remise: 'Référence de la remise',
    reference_transaction: 'Référence de la transaction',
    montant_origine: "Montant d'origine",
    taux_change: 'Taux de change',
    compte_beneficiaire: 'Compte bénéficiaire',
    compte_debiteur: 'Compte débiteur',
    num_ecriture: 'N° Pièce',
    nature_paiement: 'Nature de paiement',
    rum: 'RUM',
    libelle_retour: 'Libellé retour',
  },
  reconciliation: {
    rappro_mvt: 'Mouvements rapprochés',
    rappro_prev: 'Prévisions rapprochées',
    rappro_entry: 'Ecritures rapprochées',
    columns: {
      label: 'Libellé',
      category: 'Catégorie',
      nature: 'Nature',
      value_date: 'Date valeur',
      flux: 'Flux Comptable',
      op_date: 'Date Opération',
      amount: 'Montant',
      currency: 'Devise',
      compte: 'Compte',
    },
    footerRows: {
      num_mvt: 'Nombre de mouvements',
      amount_mvt: 'Montant des mouvements',
      num_prev: 'Nombre de prévisions',
      amount_prev: 'Montant des prévisions',
      num_entries: "Nombre d'écritures",
      amount_entries: 'Montant des écritures',
    },
    user: 'Utilisateur',
    date: 'Date',
    reconciliation_num: 'N° de Rapprochement',
    nature_code: 'Code Nature',
  },
  modal_structured_adress: {
    title: "Génération d'adresse structurée",
    placeholder: 'Saisissez l’adresse ici',
    cancel: 'Annuler',
    send: 'Générer',
    generate: 'Générer l’adresse structurée',
  },
}

